import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import useApiEp from "../../hooks/useApiEp";
import LoadingWidget from "../../widgets/LoadingWidget";
import SocialContainer from "./SocialContainer";
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import { getErrorResponse } from "../../utils/util";
import { FaWhatsapp } from "react-icons/fa";

const LinkPhoneNumber = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useApiEp(
    `/api/link-token?id=${id}`
  );

  if (isLoading) {
    return <LoadingWidget label="Checking link...." />;
  }

  if (isError) {
    return (
      <SocialContainer>
        <Alert severity="error" sx={{ mb: 2 }}>
          {getErrorResponse(error)}
        </Alert>
      </SocialContainer>
    );
  }

  return (
    <SocialContainer>
      <Container maxWidth="md" sx={{ position: "relative", zIndex: 1, py: 4 }}>
        <Paper
          elevation={8}
          sx={{
            p: 4,
            borderRadius: 3,
            background: "white",
            boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
          }}
        >
          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
              }}
            >
              <FaWhatsapp
                style={{
                  color: "#25D366",
                  fontSize: "2.5rem",
                  marginRight: "10px",
                }}
              />
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "700",
                  background:
                    "linear-gradient(135deg, #1976d2 0%, #25D366 100%)",
                  backgroundClip: "text",
                  textFillColor: "transparent",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                WhatsApp Business API
              </Typography>
            </Box>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
              Connect with your customers at scale
            </Typography>

            {/* WhatsApp Connect Button */}
            <Button
              variant="contained"
              startIcon={<FaWhatsapp />}
              sx={{
                mt: 2,
                mb: 3,
                py: 1.5,
                px: 4,
                fontSize: "1.1rem",
                fontWeight: "600",
                borderRadius: 2,
                background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                boxShadow: "0 4px 12px rgba(37, 211, 102, 0.3)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #128C7E 0%, #075E54 100%)",
                  boxShadow: "0 6px 16px rgba(37, 211, 102, 0.4)",
                  transform: "translateY(-2px)",
                },
                transition: "all 0.3s ease",
              }}
              onClick={() => {
                if (data?.customerId) {
                  localStorage.setItem("cusId", data?.customerId);
                  localStorage.setItem("partner", "haptik");
                  window.launchWhatsAppSignup("1108770184427834");
                }
              }}
            >
              Connect your WhatsApp number
            </Button>

            <Typography
              variant="caption"
              color="textSecondary"
              sx={{ mt: 3, display: "block" }}
            >
              By continuing, you agree to our{" "}
              <a
                href="https://www.smartgrowthai.com/terms"
                color="primary"
                underline="hover"
                target="_blank"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://www.smartgrowthai.com/privacypolicy"
                color="primary"
                underline="hover"
                target="_blank"
              >
                Privacy Policy
              </a>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </SocialContainer>
  );
};

export default LinkPhoneNumber;
